var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isEmpty ? _c('div', {
    key: _vm.displayField.name,
    staticClass: "field"
  }, [_vm.showLibraryStyle ? [_c('label', {
    staticClass: "bio-b4-class field-label",
    attrs: {
      "for": _vm.formattedField,
      "data-test": _vm.label,
      "aria-live": "polite"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-b4-class field-item"
  }, [_vm.vHtmlIsSet ? _c('div', {
    staticClass: "computed-html-item",
    attrs: {
      "data-test": "computedHtml",
      "aria-live": "polite",
      "aria-label": _vm.computedHtml
    },
    domProps: {
      "innerHTML": _vm._s(_vm.computedHtml)
    }
  }) : _vm.isformattedFieldLengthTooLong ? _c('textarea', {
    attrs: {
      "name": _vm.formattedField,
      "rows": _vm.textareaHeight,
      "data-test": _vm.formattedField,
      "disabled": "",
      "aria-readonly": "true",
      "id": _vm.formattedField,
      "aria-live": "polite",
      "aria-label": _vm.formattedField
    },
    domProps: {
      "value": _vm.formattedField
    }
  }) : _c('input', {
    attrs: {
      "type": "text",
      "name": _vm.formattedField,
      "data-test": _vm.formattedField,
      "disabled": "",
      "aria-readonly": "true",
      "id": _vm.formattedField,
      "aria-live": "polite",
      "aria-label": _vm.formattedField
    },
    domProps: {
      "value": _vm.formattedField
    }
  }), _vm._v(" "), _vm.showLibraryStyle ? _c('div', {
    staticClass: "book-vector",
    attrs: {
      "data-test": "book-vector"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.vectorSrc,
      "alt": "material is copied from library"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "book-tooltip"
  }, [_c('img', {
    staticClass: "book-tooltip-img",
    attrs: {
      "src": _vm.toolTipSrc,
      "alt": "tooltip: material copied from library"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "book-tooltip-text",
    attrs: {
      "aria-readonly": "true"
    }
  }, [_vm._v("\n            From Library\n          ")])])]) : _vm._e()])] : [_c('div', {
    staticClass: "field-label field__label",
    class: _vm.labelClass
  }, [_vm._v("\n      " + _vm._s(_vm.label) + ":\n    ")]), _vm._v(" "), _vm.vHtmlIsSet ? _c('div', {
    staticClass: "field-item field__item",
    domProps: {
      "innerHTML": _vm._s(_vm.computedHtml)
    }
  }) : _c('div', {
    staticClass: "field-item field__item",
    class: _vm.itemClass
  }, [_vm._v("\n      " + _vm._s(_vm.formattedField) + "\n    ")])]], 2) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }